import {
  Facilities,
  PurposeEnum,
  SearchFacilities,
  TypeEnum,
} from "@/types/types";

interface FacilityRule {
  appliesTo?: {
    types?: TypeEnum[];
    purposes?: PurposeEnum[];
  };
  label: string;
  color: string;
  icon_url: string;
}

export const facilityRules: Record<keyof Facilities, FacilityRule> = {
  has_parking: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "parking",
    color: "color1",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/parking.png",
  },
  has_pool: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "pool",
    color: "color2",
    icon_url: "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/pool.png",
  },
  has_fitness_center: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "fitness-center",
    color: "color3",
    icon_url: "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/gym.png",
  },
  has_elevator: {
    appliesTo: {
      types: [
        TypeEnum.APARTMENT,
        TypeEnum.HOUSE,
        TypeEnum.OFFICE,
        TypeEnum.APARTMENT_HOUSE,
      ],
    },
    label: "elevator",
    color: "color4",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/elevator.png",
  },
  has_concierge: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.OFFICE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "concierge",
    color: "color5",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/concierge.png",
  },
  has_security: {
    appliesTo: {
      types: [
        TypeEnum.APARTMENT,
        TypeEnum.HOUSE,
        TypeEnum.OFFICE,
        TypeEnum.APARTMENT_HOUSE,
      ],
    },
    label: "security",
    color: "color1",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/security.png",
  },
  has_public_roof_deck: {
    appliesTo: { types: [TypeEnum.APARTMENT, TypeEnum.APARTMENT_HOUSE] },
    label: "public-roof-deck",
    color: "color2",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/public_roof_deck.png",
  },
  has_roof_deck: {
    appliesTo: { types: [TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE] },
    label: "roof-deck",
    color: "color3",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/roof_deck.png",
  },
  has_garage: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "garage",
    color: "color4",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/garage.png",
  },
  has_waterfront: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "waterfront",
    color: "color5",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/waterfront.png",
  },
  has_balcony: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "balcony",
    color: "color1",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/balcony.png",
  },
  has_furniture: {
    appliesTo: {
      types: [
        TypeEnum.APARTMENT,
        TypeEnum.HOUSE,
        TypeEnum.OFFICE,
        TypeEnum.APARTMENT_HOUSE,
      ],
    },
    label: "furniture",
    color: "color2",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/furniture.png",
  },
  has_garden: {
    appliesTo: { types: [TypeEnum.APARTMENT, TypeEnum.APARTMENT_HOUSE] },
    label: "garden",
    color: "color3",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/garden.png",
  },
  has_wine_cellar: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "wine-cellar",
    color: "color4",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/wine_cellar.png",
  },
  has_ac: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "ac",
    color: "color5",
    icon_url: "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/ac.png",
  },
  has_sauna: {
    appliesTo: { types: [TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE] },
    label: "sauna",
    color: "color1",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/sauna.png",
  },
  has_gated_community: {
    appliesTo: { types: [TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE] },
    label: "gated-community",
    color: "color2",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/gated_community.png",
  },
  is_pet_friendly: {
    appliesTo: {
      purposes: [PurposeEnum.FORRENT],
      types: [
        TypeEnum.APARTMENT,
        TypeEnum.HOUSE,
        TypeEnum.OFFICE,
        TypeEnum.APARTMENT_HOUSE,
      ],
    },
    label: "pet-friendly",
    color: "color3",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/pet_friendly.png",
  },
  has_utilities_included: {
    appliesTo: {
      purposes: [PurposeEnum.FORRENT],
      types: [
        TypeEnum.APARTMENT,
        TypeEnum.HOUSE,
        TypeEnum.OFFICE,
        TypeEnum.APARTMENT_HOUSE,
      ],
    },
    label: "utilities-included",
    color: "color4",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/utilities_included.png",
  },
  has_disabled_access: {
    appliesTo: {
      purposes: [PurposeEnum.FORRENT],
      types: [
        TypeEnum.APARTMENT,
        TypeEnum.HOUSE,
        TypeEnum.OFFICE,
        TypeEnum.APARTMENT_HOUSE,
      ],
    },
    label: "disabled-access",
    color: "color5",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/disabled_access.png",
  },
  is_ready_to_move_in: {
    appliesTo: {
      purposes: [PurposeEnum.FORRENT],
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "ready-to-move-in",
    color: "color1",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/ready_to_move.png",
  },
  has_gas: {
    appliesTo: { types: [TypeEnum.LAND] },
    label: "gas",
    color: "color2",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/has_gas.png",
  },
  has_electricity: {
    appliesTo: { types: [TypeEnum.LAND] },
    label: "electricity",
    color: "color3",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/has_electricity.png",
  },
  has_water: {
    appliesTo: { types: [TypeEnum.LAND] },
    label: "water",
    color: "color4",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/has_water.png",
  },
  has_sewage: {
    appliesTo: { types: [TypeEnum.LAND] },
    label: "sewage",
    color: "color5",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/has_sewage.png",
  },
  has_cafeteria: {
    appliesTo: { types: [TypeEnum.OFFICE] },
    label: "cafeteria",
    color: "color1",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/cafeteria.png",
  },
  has_conference_room: {
    appliesTo: { types: [TypeEnum.OFFICE] },
    label: "conference-room",
    color: "color2",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/conference_room.png",
  },
  has_hoa: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "has-hoa",
    color: "color3",
    icon_url: "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/hoa.png",
  },
  has_public_transport: {
    appliesTo: {
      types: [
        TypeEnum.APARTMENT,
        TypeEnum.HOUSE,
        TypeEnum.LAND,
        TypeEnum.OFFICE,
        TypeEnum.APARTMENT_HOUSE,
      ],
    },
    label: "public-transport",
    color: "color4",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/public_transport.png",
  },
  has_intercom: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "intercom",
    color: "color5",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/intercom.png",
  },
  has_dishwasher: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "dishwasher",
    color: "color1",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/dishwasher.png",
  },
  has_internet: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "internet",
    color: "color2",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/internet.png",
  },
  has_terrace: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "terrace",
    color: "color3",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/terrace.png",
  },
  has_barbecue: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "barbecue",
    color: "color4",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/barbecue.png",
  },
  has_guest_suites: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "guest-suites",
    color: "color5",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/guest_rooms.png",
  },
  has_guest_house: {
    appliesTo: {
      types: [TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "guest-house",
    color: "color1",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/guest_house.png",
  },
  has_valet: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.APARTMENT_HOUSE],
    },
    label: "valet",
    color: "color2",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/valet.png",
  },
  has_alarm: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "alarm",
    color: "color3",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/alarm.png",
  },
  has_dining_room: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "dining-room",
    color: "color4",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/dining_room.png",
  },
  has_ev_charging: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "ev-charging",
    color: "color5",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/ev_charging.png",
  },
  has_hot_tub: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "hot-tub",
    color: "color1",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/hot_tub.png",
  },
  has_washing_machine: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "washing-machine",
    color: "color2",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/washing_machine.png",
  },
  has_tennis_court: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "tennis-court",
    color: "color3",
    icon_url:
      "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/tennis_court.png",
  },
  has_yoga: {
    appliesTo: {
      types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
    },
    label: "yoga",
    color: "color4",
    icon_url: "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/yoga.png",
  },
};

export const searchFacilityRules: Record<keyof SearchFacilities, FacilityRule> =
  {
    has_parking: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "parking",
      color: "color1",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/parking.png",
    },
    has_pool: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "pool",
      color: "color2",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/pool.png",
    },
    has_fitness_center: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "fitness-center",
      color: "color3",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/gym.png",
    },
    has_elevator: {
      appliesTo: {
        types: [
          TypeEnum.APARTMENT,
          TypeEnum.HOUSE,
          TypeEnum.OFFICE,
          TypeEnum.APARTMENT_HOUSE,
        ],
      },
      label: "elevator",
      color: "color4",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/elevator.png",
    },
    has_concierge: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.OFFICE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "concierge",
      color: "color5",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/concierge.png",
    },
    has_security: {
      appliesTo: {
        types: [
          TypeEnum.APARTMENT,
          TypeEnum.HOUSE,
          TypeEnum.OFFICE,
          TypeEnum.APARTMENT_HOUSE,
        ],
      },
      label: "security",
      color: "color1",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/security.png",
    },
    has_public_roof_deck: {
      appliesTo: { types: [TypeEnum.APARTMENT, TypeEnum.APARTMENT_HOUSE] },
      label: "public-roof-deck",
      color: "color2",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/public_roof_deck.png",
    },
    has_roof_deck: {
      appliesTo: { types: [TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE] },
      label: "roof-deck",
      color: "color3",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/roof_deck.png",
    },
    has_garage: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "garage",
      color: "color4",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/garage.png",
    },
    has_waterfront: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "waterfront",
      color: "color5",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/waterfront.png",
    },
    has_balcony: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "balcony",
      color: "color1",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/balcony.png",
    },
    has_furniture: {
      appliesTo: {
        types: [
          TypeEnum.APARTMENT,
          TypeEnum.HOUSE,
          TypeEnum.OFFICE,
          TypeEnum.APARTMENT_HOUSE,
        ],
      },
      label: "furniture",
      color: "color2",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/furniture.png",
    },
    has_garden: {
      appliesTo: { types: [TypeEnum.APARTMENT, TypeEnum.APARTMENT_HOUSE] },
      label: "garden",
      color: "color3",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/garden.png",
    },
    has_wine_cellar: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "wine-cellar",
      color: "color4",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/wine_cellar.png",
    },
    has_ac: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "ac",
      color: "color5",
      icon_url: "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/ac.png",
    },
    has_sauna: {
      appliesTo: { types: [TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE] },
      label: "sauna",
      color: "color1",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/sauna.png",
    },
    has_gated_community: {
      appliesTo: { types: [TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE] },
      label: "gated-community",
      color: "color2",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/gated_community.png",
    },
    is_pet_friendly: {
      appliesTo: {
        purposes: [PurposeEnum.FORRENT],
        types: [
          TypeEnum.APARTMENT,
          TypeEnum.HOUSE,
          TypeEnum.OFFICE,
          TypeEnum.APARTMENT_HOUSE,
        ],
      },
      label: "pet-friendly",
      color: "color3",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/pet_friendly.png",
    },
    has_utilities_included: {
      appliesTo: {
        purposes: [PurposeEnum.FORRENT],
        types: [
          TypeEnum.APARTMENT,
          TypeEnum.HOUSE,
          TypeEnum.OFFICE,
          TypeEnum.APARTMENT_HOUSE,
        ],
      },
      label: "utilities-included",
      color: "color4",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/utilities_included.png",
    },
    has_disabled_access: {
      appliesTo: {
        purposes: [PurposeEnum.FORRENT],
        types: [
          TypeEnum.APARTMENT,
          TypeEnum.HOUSE,
          TypeEnum.OFFICE,
          TypeEnum.APARTMENT_HOUSE,
        ],
      },
      label: "disabled-access",
      color: "color5",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/disabled_access.png",
    },
    is_ready_to_move_in: {
      appliesTo: {
        purposes: [PurposeEnum.FORRENT],
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "ready-to-move-in",
      color: "color1",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/ready_to_move.png",
    },
    has_gas: {
      appliesTo: { types: [TypeEnum.LAND] },
      label: "gas",
      color: "color2",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/has_gas.png",
    },
    has_electricity: {
      appliesTo: { types: [TypeEnum.LAND] },
      label: "electricity",
      color: "color3",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/has_electricity.png",
    },
    has_water: {
      appliesTo: { types: [TypeEnum.LAND] },
      label: "water",
      color: "color4",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/has_water.png",
    },
    has_sewage: {
      appliesTo: { types: [TypeEnum.LAND] },
      label: "sewage",
      color: "color5",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/has_sewage.png",
    },
    has_cafeteria: {
      appliesTo: { types: [TypeEnum.OFFICE] },
      label: "cafeteria",
      color: "color1",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/cafeteria.png",
    },
    has_conference_room: {
      appliesTo: { types: [TypeEnum.OFFICE] },
      label: "conference-room",
      color: "color2",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/conference_room.png",
    },
    has_hoa: {
      appliesTo: {
        types: [TypeEnum.APARTMENT, TypeEnum.HOUSE, TypeEnum.APARTMENT_HOUSE],
      },
      label: "has-hoa",
      color: "color3",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/pool.png",
    },
    has_public_transport: {
      appliesTo: {
        types: [
          TypeEnum.APARTMENT,
          TypeEnum.HOUSE,
          TypeEnum.LAND,
          TypeEnum.OFFICE,
          TypeEnum.APARTMENT_HOUSE,
        ],
      },
      label: "public-transport",
      color: "color4",
      icon_url:
        "https://d1ktxmigjvpff7.cloudfront.net/facilities-icons/pool.png",
    },
  };

export function getAvailableFacilities(
  type: TypeEnum,
  purpose: PurposeEnum
): (keyof Facilities)[] {
  return (Object.keys(facilityRules) as (keyof Facilities)[]).filter((key) => {
    const rule = facilityRules[key];
    const appliesTo = rule.appliesTo;

    const typeMatch = !appliesTo?.types || appliesTo.types.includes(type);
    const purposeMatch =
      !appliesTo?.purposes || appliesTo.purposes.includes(purpose);

    return typeMatch && purposeMatch;
  });
}

export function getAvailableSeachFacilities(
  type: TypeEnum,
  purpose: PurposeEnum
): (keyof SearchFacilities)[] {
  return (
    Object.keys(searchFacilityRules) as (keyof SearchFacilities)[]
  ).filter((key) => {
    const rule = searchFacilityRules[key];
    const appliesTo = rule.appliesTo;

    const typeMatch = !appliesTo?.types || appliesTo.types.includes(type);
    const purposeMatch =
      !appliesTo?.purposes || appliesTo.purposes.includes(purpose);

    return typeMatch && purposeMatch;
  });
}
